import * as React from 'react';
import { Text } from '@grandvisionhq/elements';

const AppointmentPickDifferentTimeSlotNotAvailable = ({ labels , onClickPrevious  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "appointment-pick-different-time-slot__not-available"
    }, /*#__PURE__*/ React.createElement(Text, null, labels.noTimesAvailableOn), /*#__PURE__*/ React.createElement("button", {
        className: "appointment-pick-different-time-slot__previous",
        onClick: onClickPrevious,
        type: "button"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "link",
        className: "appointment-pick-different-time-slot__link"
    }, labels.noTimesSelectAnotherDay)));
};

export { AppointmentPickDifferentTimeSlotNotAvailable as default };
//# sourceMappingURL=AppointmentPickDifferentTimeSlotNotAvailable.js.map
